// Channel types for CEP
export enum ChannelType {
  Email = "email",
  Sms = "sms",
  Push = "push",
}
